import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import codeslateIcon from '../../assets/codeslate-logo.png';
import './BlogListingPage.css';

const BlogListingPage: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const blogPosts = [
    {
      id: 'best-coding-interview-platform-for-startups',
      title: 'Best Coding Interview Platform for Startups',
      excerpt: 'Looking for the best coding interview platform for startups? Compare features, pricing, and workflows to pick a lightweight tool that scales with your hiring.',
      date: 'January 2026',
      readTime: '9 min read',
      category: 'Technical Interviews',
      slug: 'best-coding-interview-platform-for-startups'
    },
    {
      id: '7-best-alternatives-to-coderpad',
      title: '7 Best Alternatives to CoderPad',
      excerpt: 'Looking for CoderPad alternatives? Here are seven strong options for live coding interviews and technical assessments, plus guidance on which teams each one fits.',
      date: 'December 2025',
      readTime: '10 min read',
      category: 'Technical Interviews',
      slug: '7-best-alternatives-to-coderpad'
    },
    {
      id: 'technical-interview-platforms-comparison',
      title: 'The Complete Guide to Technical Interview Platforms: CoderPad vs HackerRank vs CodeSignal vs Codility vs CodeSlate',
      excerpt: 'Choosing the right technical interview platform can make or break your hiring process. In this comprehensive comparison, we analyze five popular platforms to help you make an informed decision.',
      date: 'December 2024',
      readTime: '12 min read',
      category: 'Technical Interviews',
      slug: 'technical-interview-platforms-comparison'
    }
    // Add more blog posts here as you create them
  ];

  return (
    <div className="blog-listing-page">
      {/* Header */}
      <header className="blog-header">
        <div className="blog-header-content">
          <Link to="/" className="blog-logo">
            <img src={codeslateIcon} alt="CodeSlate" className="blog-logo-img" />
            <span className="blog-logo-text">CodeSlate</span>
          </Link>
          <nav className="blog-nav">
            <Link to="/" className="blog-nav-link">Home</Link>
            <Link to="/faq" className="blog-nav-link">FAQ</Link>
            <Link to="/contact" className="blog-nav-link">Contact</Link>
          </nav>
        </div>
      </header>

      {/* Main Content */}
      <main className="blog-listing-main">
        <div className="blog-listing-container">
          {/* Page Header */}
          <div className="blog-listing-header">
            <h1>CodeSlate Blog</h1>
            <p>Insights, tips, and comparisons for technical hiring and interview platforms</p>
          </div>

          {/* Blog Posts Grid */}
          <div className="blog-posts-grid">
            {blogPosts.map((post) => (
              <article key={post.id} className="blog-post-card">
                <div className="blog-post-meta">
                  <span className="blog-post-date">{post.date}</span>
                  <span className="blog-post-read-time">{post.readTime}</span>
                  <span className="blog-post-category">{post.category}</span>
                </div>
                
                <h2 className="blog-post-title">
                  <Link to={`/blog/${post.slug}`} className="blog-post-link">
                    {post.title}
                  </Link>
                </h2>
                
                <p className="blog-post-excerpt">{post.excerpt}</p>
                
                <div className="blog-post-footer">
                  <Link to={`/blog/${post.slug}`} className="read-more-btn">
                    Read More →
                  </Link>
                </div>
              </article>
            ))}
          </div>

        </div>
      </main>

      {/* Footer */}
      <footer className="blog-footer">
        <div className="blog-footer-content">
          <div className="blog-footer-links">
            <Link to="/" className="footer-link">Home</Link>
            <Link to="/faq" className="footer-link">FAQ</Link>
            <Link to="/contact" className="footer-link">Contact</Link>
            <Link to="/blog" className="footer-link">Blog</Link>
          </div>
          <div className="blog-footer-bottom">
            <p>&copy; 2024 CodeSlate. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default BlogListingPage;
